import { useEffect, useState } from 'react'
import AdminLayout from '../components/Layouts/AdminLayout'
import HeaderContainer from '../containers/Header/Header.container'
import SidebarContainer from '../containers/Sidebar/Sidebar.container'
import ProfileContainer from '../containers/UserProfile/UserProfile.container'
import PensionConfigContainer from '../containers/PensionConfig/PensionConfig.container'
import ThemeSwitcher from '../components/Theme/ThemeSwitcher'
import PagePanel, { PageStack } from '../components/Layouts/PagePanel'

const METHOD_SECTION_ID = 'metodo-de-calculo'
const HIGHLIGHT_MS = 2500
/** Fixed header (60px) + extra space so the panel is fully visible */
const SCROLL_OFFSET_PX = 88

const Preferences = () => {
  const [highlightMethod, setHighlightMethod] = useState(false)

  useEffect(() => {
    const hash = window.location.hash?.replace('#', '')
    if (hash !== METHOD_SECTION_ID) return undefined

    const target = document.getElementById(METHOD_SECTION_ID)
    if (!target) return undefined

    const top =
      target.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET_PX
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' })
    setHighlightMethod(true)

    const timeoutId = window.setTimeout(() => {
      setHighlightMethod(false)
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}${window.location.search}`
      )
    }, HIGHLIGHT_MS)

    return () => window.clearTimeout(timeoutId)
  }, [])

  return (
    <AdminLayout
      header={<HeaderContainer />}
      sidebar={<SidebarContainer />}
    >
      <PageStack>
        <PagePanel title="Mi perfil">
          <ProfileContainer />
        </PagePanel>
        <PagePanel
          id={METHOD_SECTION_ID}
          title="Cómo se fija tu pensión"
          highlighted={highlightMethod}
        >
          <PensionConfigContainer />
        </PagePanel>
        <PagePanel title="Apariencia del sitio">
          <ThemeSwitcher />
        </PagePanel>
      </PageStack>
    </AdminLayout>
  )
}

export default Preferences
